import { useCallback, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { postKaKao, postSendCode, postVerifyCode } from '../../api/login'
import { fadeIn, fadeOut, slideDown, slideUp } from '../../js/animation'
import { Title } from '../../pages/search/Search'

// 이미지 경로
const imgURL = '/images'

interface PropsType {
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>
  isModal: boolean
  setVerificationCheckCode: React.Dispatch<React.SetStateAction<string>>
  setPhone: React.Dispatch<React.SetStateAction<string>>
}

/**
 * 모달 팝업 - 전체 화면
 *
 * @params {React.ReactNode} content - 콘텐츠 내용
 * @params {string} headerText - 모달 헤더 제목
 */

export default function PhoneChangeModal({ setIsModal, isModal, setVerificationCheckCode, setPhone }: PropsType) {
  const [closing, setClosing] = useState<boolean>(false) // 닫힘 애니메이션 적용에 필요
  const [phoneNumber, setPhoneNumber] = useState<string>('')
  const [messageId, setMessageId] = useState<string>('')
  const [code, setCode] = useState<string>('')
  const [drop, setDrop] = useState<boolean>(false)
  const [snsCheck, setSnsCheck] = useState<boolean>(false)
  const [phoneSubmit, setPhoneSubmit] = useState<boolean>(false)
  const [seconds, setSeconds] = useState<number>(20)
  const [phoneFocus, setPhoneFocus] = useState<boolean>(false)
  const [codeFocus, setCodeFocus] = useState<boolean>(false)
  const [phonecheck, setPhoneCheck] = useState<boolean>(false)
  const [time, setTime] = useState<number>(3 * 60) // 3분을 초로 변환 (3분 * 60초)
  const [isActive, setIsActive] = useState<boolean>(false)
  const [authCheck, setAuthCheck] = useState<boolean>(false)
  const timerRef = useRef(null) // Add this line
  const phoneContRef = useRef<HTMLDivElement>(null)

  const decrementSeconds = useCallback(() => {
    setSeconds((prevSeconds) => prevSeconds - 1)
  }, [])

  useEffect(() => {
    if (phoneSubmit) {
      //@ts-ignore
      timerRef.current = setInterval(decrementSeconds, 1000) // Change this line
      //@ts-ignore
      return () => clearInterval(timerRef.current)
    }
  }, [decrementSeconds, phoneSubmit])

  useEffect(() => {
    if (seconds === 0) {
      //@ts-ignore
      clearInterval(timerRef.current) // Change this line
    }
  }, [seconds])

  useEffect(() => {
    setPhoneNumber('')
  }, [])

  useEffect(() => {
    let interval: any = null
    if (isActive && time > 0) {
      interval = setInterval(() => {
        setTime((time) => time - 1)
      }, 1000)
    } else if (time === 0) {
      clearInterval(interval)
      setIsActive(false)
    }
    return () => clearInterval(interval)
  }, [isActive, time])

  const formatTime = (seconds: any) => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`
  }

  // body 스크롤 제어
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  useEffect(() => {
    if (phoneFocus) {
      phoneContRef.current?.classList.add('focus')
    } else {
      phoneContRef.current?.classList.remove('focus')
    }
  }, [phoneFocus])

  useEffect(() => {
    if (seconds === 0) {
      //@ts-ignore
      clearInterval(timerRef.current) // Change this line
    }
  }, [seconds])

  const closeModal = () => {
    setClosing(true)

    setTimeout(() => {
      setIsModal(false)
      setClosing(false)
    }, 280)
  }

  function validatePhoneNumber(number: any) {
    const phonePattern = /^(01[016789])-?\d{3,4}-?\d{4}$/

    if (phonePattern.test(number)) {
      setPhoneCheck(true)
    } else {
      setPhoneCheck(false)
    }
  }

  if (!isModal) return null
  return (
    <ModalWrap>
      <ModalBox closing={closing}>
        <ModalHeader>
          <p></p>
          <button className='btn_close' onClick={closeModal}>
            <img src={`${imgURL}/icon_close.png`} alt='닫기' />
          </button>
        </ModalHeader>

        <div className='profile_wrap' style={{ padding: '0 24px', height: '100%' }}>
          <Title style={{ marginBottom: '24px' }}>휴대폰 번호 변경</Title>
          <div className='profile_info'>
            <div className='inp_box'>
              <p>
                휴대폰 번호
                {phoneNumber && !phonecheck ? <em>휴대폰번호를 확인해주세요.</em> : null}
              </p>

              <div
                className={
                  phoneNumber && !phonecheck
                    ? 'phone_cont '
                    : phoneNumber && phonecheck && phoneFocus
                    ? 'phone_cont'
                    : 'phone_cont'
                }
                ref={phoneContRef}
              >
                <input
                  type='number'
                  placeholder='휴대폰번호를 입력해주세요.'
                  onChange={(e) => {
                    setPhoneNumber(e.target.value)
                    validatePhoneNumber(e.target.value)
                  }}
                  onFocus={() => {
                    setPhoneFocus(true)
                  }}
                  onBlur={() => {
                    setPhoneFocus(false)
                  }}
                  style={{ outline: 'none' }}
                  maxLength={11}
                />
                {phoneSubmit ? (
                  seconds === 0 ? (
                    <button
                      type='button'
                      className='certf_btn'
                      style={{ minWidth: '37px' }}
                      onClick={() => {
                        if (phoneNumber && phonecheck) {
                          setPhoneSubmit(true)
                          setIsActive(true)
                          postSendCode(phoneNumber)
                            .then((res) => {
                              setMessageId(res.data.messageId)
                              setSeconds(20)
                              setTime(3 * 59 + 2)
                            })
                            .catch((err) => console.log(err))
                        } else {
                          alert('휴대폰번호를 입력해주세요')
                        }
                      }}
                    >
                      재전송
                    </button>
                  ) : (
                    <p className='certf_btn' style={{ minWidth: 'auto' }}>
                      {seconds}
                    </p>
                  )
                ) : (
                  <button
                    type='button'
                    className='certf_btn'
                    onClick={() => {
                      if (phoneNumber && phonecheck) {
                        setPhoneSubmit(true)
                        setIsActive(true)
                        postSendCode(phoneNumber)
                          .then((res) => {
                            setMessageId(res.data.messageId)
                          })
                          .catch((err) => console.log(err))
                      } else {
                        alert('휴대폰번호를 입력해주세요')
                      }
                    }}
                  >
                    인증요청
                  </button>
                )}
              </div>
            </div>
            {phoneSubmit ? (
              <div className='inp_box'>
                <p>
                  인증번호
                  {authCheck ? <em>인증번호를 잘못 입력했습니다.</em> : null}
                </p>
                <div
                  className={codeFocus ? 'certf_cont' : 'certf_cont'}
                  // style={{
                  //   borderColor: codeFocus
                  //     ? "rgba(255, 23, 23, 0.60)"
                  //     : colorObj.colGray3,
                  // }}
                >
                  <input
                    type='text'
                    inputMode='numeric'
                    placeholder='4자리 인증번호를 입력해주세요.'
                    maxLength={4}
                    onChange={(e) => {
                      setCode(e.target.value)
                    }}
                    onFocus={() => {
                      setCodeFocus(true)
                    }}
                    onBlur={() => {
                      setCodeFocus(false)
                    }}
                    style={{ outline: 'none' }}
                  />
                  <em>{formatTime(time)}</em>
                  <span style={{ color: 'var(--colBlack)' }}>
                    인증번호를 발송했습니다. <br />
                    인증번호가 오지 않는다면 휴대폰번호를 다시 확인해보세요.
                  </span>
                  <button
                    type='button'
                    className={snsCheck ? 'on' : ''}
                    onClick={() => {
                      setSnsCheck((prev: boolean) => !prev)
                    }}
                  >
                    문자가 오지 않았나요?
                  </button>
                  {snsCheck ? (
                    <div className='dropdown_box'>
                      <a
                        href=''
                        onClick={(e) => {
                          e.preventDefault()
                          postKaKao(phoneNumber)
                            .then((res) => {
                              setMessageId(res.data.message)
                            })
                            .catch((err) => console.log(err))
                        }}
                      >
                        카카오톡으로 인증번호 받기
                      </a>
                      <a href='https://app-bridge.aboutfishing.kr/faq/37'>인증 문자 오류 해결하기</a>
                    </div>
                  ) : null}
                </div>
              </div>
            ) : null}
          </div>
        </div>
        <div className='bot_txt_box'>
          <button
            type='button'
            className='btn_save'
            style={{
              borderRadius: 0,
              background: code.length !== 0 ? 'var(--colBlack)' : 'var(--colGray2)',
              color: code.length !== 0 ? 'var(--colWhite)' : 'var(--colGray4)',
            }}
            onClick={() => {
              postVerifyCode(phoneNumber, messageId, code)
                .then((res) => {
                  if (res.data.code === 'E0115') {
                    setAuthCheck(true)
                  } else {
                    setPhone(phoneNumber)
                    setVerificationCheckCode(res.data.verificationCheckCode)
                    closeModal()
                  }
                })
                .catch((err) => setAuthCheck(true))
            }}
          >
            확인
          </button>
        </div>
      </ModalBox>
      <ModalBackground onClick={closeModal} closing={closing}></ModalBackground>
    </ModalWrap>
  )
}

interface typeProps {
  closing?: boolean
}

export const ModalBackground = styled.div<typeProps>`
  width: 100%;
  height: 100vh;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  animation: ${({ closing }) => (closing ? fadeOut : fadeIn)} 0.3s ease-in-out;
`

export const ModalWrap = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: 20;
`

export const ModalBox = styled.div<typeProps>`
  width: 100%;
  height: 100%;
  background-color: var(--colWhite);
  animation: ${({ closing }) => (closing ? slideDown : slideUp)} 0.3s ease-in-out;
  position: absolute;
  z-index: 30;
  display: flex;
  flex-direction: column;
`

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  align-items: center;
  & button.btn_close {
    width: 24px;
    height: 24px;
    margin: 12px;
    background: none;
    border: none;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
`

export const ModalBody = styled.div``

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
`
